<app-street-search-form
  (filterData)="filterStreets($event)"
  (streetSelected)="selectStreetByGeocode($event)"
  *ngIf="showSearch"
  [initialSearch]="initialSearch?.description || ''"
  [inputOnly]="searchInputOnly"
  [priceRange]="priceRange"></app-street-search-form>

<div #mapRef class="map"></div>

<div #controlsTmpl class="mapboxgl-ctrl mapboxgl-ctrl-group">
  <ng-container *ngIf="showControls">
    <button (click)="toggleStyle()" class="style-toggle">{{ is3D ? '2D' : '3D' }}</button>
  </ng-container>
</div>
<div #mobilePopupTmpl class="mobile-popup"></div>
